module.exports = __webpack_public_path__ + "img/magento-modules-customization_medium@2x.7a810046.jpg";